import React, { useState, useMemo, useEffect } from "react"
import TopNavbar from "../../shares/TopNavbar"
import * as Account from '../../account';
import * as api from '../../services/api'
import { sortOnKeys, locale } from "../../utils";

export default function Logs(props) {

    const [data, setData] = useState([])

    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const platform = params.get('platform');
    const status = params.get('status');
    const normalizedPlatform = ["quickbooks_online", "quickbooks_desktop", "csv"].includes(platform || "") ? platform : "";
    const normalizedStatus = ["OK", "ERROR"].includes(status || "") ? status : "";

    const [filter, setFilter] = useState({
        platform: normalizedPlatform,
        status: normalizedStatus,
    })

    useEffect(() => {
        logs(filter)
    }, [])

    const logs = (data) => {
        api.logs(data)
            .then(response => {
                setData(response)
            })
            .catch(err => {
                console.log(err)
            })
    }
    const deleteLog = (id) => {
        if (!window.confirm('Are you sure you want to delete?')) 
            return
        api.deleteLog(id).finally(() => logs(filter))
    };


    const parseStatus = (item) => {
        var data = JSON.parse(item)

        if (!data) return "FAILED";

        var result = data.result

        if (!result) return "FAILED"

        if (result.order)
            return result.order.error_message ? "FAILED" : data.status

        if (data.job == "order" && (!result.synced || result.synced.length == 0)) return "FAILED";

        if (result.synced && Array.isArray(result.synced))
            return result.synced.map(t => t.Error ? "FAILED" : data.status).join(',').split(",")[0]


        return data.status

    }

    const parseResult = (item) => {
        var data = JSON.parse(item)

        if (!data) return "";

        var result = data.result

        if (!result) return `No new ${data.job}s to sync`;


        if (result.order)
            return result.order.Order + (result.order.error_message ? " import failed. " 
            : ` imported successfully to ${result.order.Company && result.order.Company.Name ? result.order.Company.Name + " - " : ""} ${result.order.Customer && result.order.Customer.Name ? result.order.Customer.Name + "'s" : ""} ${result.order.RefNumber}.`) 
            + (result.order.Notfound && result.order.Notfound?.length > 0 ? `\nThe following products were not found in QuickBooks:\n${result.order.Notfound.join("\n")}` : result.order.error_message ? result.order.error_message : "")

        if (result.synced && Array.isArray(result.synced))
            return result.synced.map(t => "Fora " + (t.ForaOrder || t.Quote || t.Order || t.Group)
                + (t.QBOrder ? " successfully import to\n" + (locale(filter.platform) || filter.platform) + ". QuickBooks " + t.QBOrder.DocNumber : (t.Error ? " failed to import to " + (locale(filter.platform) || filter.platform) : "")) 
                + (t.Notfound && t.Notfound?.length > 0 ? `\nThe following products were not found in QuickBooks:\n${t.Notfound.join("\n")}` : t.error_message ? t.error_message : "")
            ).join('\n\n')


        if (result.fora_response) {
            try {
                return JSON.parse(result.fora_response).Message
            } catch {
                return result.fora_response
            }
        }

        return result.error_message
    }

    function formatDate(dbDateString) {

        // Create a new Date object with the database date string
        const dbDate = new Date(dbDateString);

        // Get the machine timezone offset in minutes
        const timezoneOffset = new Date().getTimezoneOffset();

        // Convert the timezone offset to milliseconds
        const timezoneOffsetMs = timezoneOffset * 60 * 1000;

        // Get the machine date by adding the timezone offset to the database date
        const machineDate = new Date(dbDate.getTime() - timezoneOffsetMs);

        // Format the machine date as a string in the machine timezone
        return machineDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            timeZone: 'UTC',
            hour12: false
        })
    }

    function handleOptionChange(e) {
        var { name, value } = e.target
        setFilter({ ...filter, [name]: value })
    }

    useEffect(() => {
        logs(filter)
    }, [filter])

    return (
        <div className="min-h-full">
            <TopNavbar />
            <header className="bg-white shadow">
                <div className="mx-auto max-w-7xl py-6 px-4 sm:px-6 lg:px-8">
                    <div className="relative min-h-[40px]">
                        <a href={`/?platform=${filter.platform}`} className="absolute left-0 top-0 text-gray-500 font-bold p-1 m-2 whitespace-nowrap">
                            <span className="mr-2 text-xl">&larr;</span>Dashboard
                        </a>
                        <h1 className="px-28 text-center text-xl font-bold tracking-tight text-gray-900">Logs</h1>
                        <a
                            href={filter.platform == "quickbooks_desktop" ? "/jobs/desktop" : filter.platform == "csv" ? "/jobs/csv" : "/jobs"}
                            className="absolute right-0 top-0 text-gray-500 font-bold p-1 m-2 whitespace-nowrap"
                        >
                            Run process<span className="ml-2 text-xl">&rarr;</span>
                        </a>
                    </div>
                </div>
            </header>
            <main className="container mx-auto px-4 w-full items-center justify-center">
                <div className="min-h-screen">
                    <div className="max-w-4xl mx-auto py-4">
                        <div className="space-y-6 w-full">
                            <div className="bg-white shadow-lg rounded-lg px-6 py-4 flex items-center justify-between">
                                <div className="w-full">
                                    <span className="flex flex-row items-center">
                                        <h2 className="font-bold text-gray-900">Filter</h2>
                                    </span>
                                    <div className="grid grid-cols-2 gap-2">
                                        <div className="relative m-2">
                                            <select value={filter.platform} onChange={handleOptionChange} name="platform" className="w-full appearance-none bg-white border-2 border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline" id="select-option">
                                                <option value="">All platform</option>
                                                <option value="quickbooks_online">QuickBooks Online</option>
                                                <option value="quickbooks_desktop">QuickBooks Desktop</option>
                                                <option value="csv">CSV </option>
                                            </select>
                                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                    <path d="M10 12l-5-5 1.41-1.41L10 9.17l3.59-3.58L15 7z" />
                                                </svg>
                                            </div>
                                        </div>
                                        <div className="relative m-2">
                                            <select value={filter.status} onChange={handleOptionChange} name="status" className="w-full appearance-none bg-white border-2 border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline" id="select-option">
                                                <option value="">All status</option>
                                                <option value="OK">OK</option>
                                                <option value="ERROR">FAILED</option>
                                            </select>
                                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                                                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                    <path d="M10 12l-5-5 1.41-1.41L10 9.17l3.59-3.58L15 7z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="bg-white shadow-lg rounded-lg px-6 py-4 items-center justify-between">
                                <div className="mt-4 overflow-x-auto">
                                    <table className="divide-y divide-gray-200 table-fixed w-full">
                                        <thead className="bg-gray-50">
                                            <tr>
                                                {/* <th scope="col" className="w-1/6 px-6 py-3 text-left text-xs font-medium text-gray-500">
                                                    Platform
                                                </th> */}
                                                <th scope="col" className="w-1/6 px-6 py-3 text-left text-xs font-medium text-gray-500">
                                                    Job
                                                </th>
                                                <th scope="col" className="w-3/6 px-6 py-3 text-left text-xs font-medium text-gray-500">
                                                    Result
                                                </th>
                                                <th scope="col" className="w-2/6 px-6 py-3 text-left text-xs font-medium text-gray-500">
                                                    At
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white divide-y divide-gray-200">

                                            {data && data.map((k) => (
                                                <tr key={k.id}>
                                                    {/* <td className="px-6 py-4">
                                                        <div className="text-xs text-gray-900">
                                                            {locale(JSON.parse(k.data).platform)}
                                                        </div>
                                                    </td> */}
                                                    <td className="px-6 py-4">
                                                        <div className="text-sm text-gray-900">
                                                            {locale(JSON.parse(k.data).job)}
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                    <span className={`items-start text-xs ${parseStatus(k.data) == "OK" ? "text-green-600" : "text-red-600"} flex`}>{parseStatus(k.data)}<p className="ml-2 text-gray-900 truncate whitespace-pre-line">{parseResult(k.data)}</p></span>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-pre-line">
                                                        <div className="text-xs text-gray-900 flex">{formatDate(k.createdAt)}
                                                            <button onClick={e => {deleteLog(k.id)}} className={`ml-2 text-xs text-red-500`}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4">
                                                                    <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div >
    )
}

